module.exports = __webpack_public_path__ + "bd7b895c174c3382644643ac7ccf3961.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_ORK_EXPANDED_W_1200px_H_660px.jpg
// module id = 395
// module chunks = 0